import { defaultAction } from "./defaultAction";
import {
  SHOW_LOADING,
  SET_PAYPAL_INTERNAL_PAYMENT_ID,
  DISPLAY_MAIN_PAYMENT_ERROR
} from "@constants/actionTypes";
import { getFormValues } from "redux-form";
import { trimString, removeEmpty } from "@utils";
import { createOrder } from "./sellOrders";
import { getCardknoxData } from "@actions/getCardKnoxToken";

export const placePayPalSellOrder = () => async (dispatch, getState, api) => {
  try {
    dispatch(defaultAction(SHOW_LOADING, "complete-sell"));
    const { cartSell } = getState();
    const results = await api.post("v3/orders/paypal/checkout", {
      cartId: cartSell.cartId,
      paypalReturnUrl: "http://www.cardcash.com",
      paypalCancelUrl: "http://www.cardcash.com"
    });
    let intPaymentId = results.data.internalPaymentId + "";
    dispatch(defaultAction(SET_PAYPAL_INTERNAL_PAYMENT_ID, intPaymentId));
    return results.data.paymentId;
  } catch (error) {
    throw `placePayPalSellOrder: ${error}`;
  }
};

export const updatePayPalSellOrder =
  (paymentId, payerId, ctx) => async (dispatch, getState, api) => {
    try {
      const state = getState();
      const { cartSell, customerInfo } = state;
      const payPalSell = getFormValues("payPalSell")(state);
      let internalPaymentId = customerInfo.internalPaymentId;
      const results = await api.put("v3/orders/paypal/result", {
        cartId: cartSell.cartId,
        internalPaymentId,
        paymentId,
        payerId
      });

      let billingDetails;
      if (payPalSell.verification.sameAsPrimary) {
        billingDetails = {
          firstname: trimString(customerInfo.firstname),
          lastname: trimString(customerInfo.lastname),
          street: trimString(customerInfo.street),
          street2: trimString(customerInfo.street2),
          city: trimString(customerInfo.city),
          state: trimString(customerInfo.state),
          postcode: trimString(customerInfo.zip)
        };
      } else {
        billingDetails = {
          firstname: trimString(payPalSell.verification.firstname),
          lastname: trimString(payPalSell.verification.lastname),
          street: trimString(payPalSell.verification.street),
          street2: trimString(payPalSell.verification.street2),
          city: trimString(payPalSell.verification.city),
          state: trimString(payPalSell.verification.state),
          postcode: trimString(payPalSell.verification.zip)
        };
      }

      let monthAndYear =
        payPalSell.verification.creditCardInformation.ExpirationDate.replace(
          /\s+/g,
          ""
        ).split("/");

      const { cardNumToken, cvvNumToken } = await dispatch(getCardknoxData());

      let orderBase = {
        autoSplit: false,
        billingDetails,
        creditCardDetails: {
          save: false,
          numberToken: cardNumToken,
          cvvToken: cvvNumToken,
          expMonth: trimString(monthAndYear[0]),
          expYear: trimString(monthAndYear[1])
        },
        cartId: cartSell.cartId,
        internalPaymentId: parseInt(results.data.internalPaymentId),
        paymentId: paymentId,
        paymentMethod: "PAYPALEXPRESS"
      };
      removeEmpty(orderBase.billingDetails);
      dispatch(createOrder(orderBase, ctx.props.history));
    } catch (error) {
      if (
        error.message ===
        "Please re-enter your credit card information and try again."
      ) {
        dispatch(defaultAction(DISPLAY_MAIN_PAYMENT_ERROR, error.message));
        window.scrollTo(0, 0);
      }
      throw `updatePayPalSellOrder: ${error}`;
    }
  };
